module.exports = __webpack_public_path__ + "media/ingredients/sweet-potato--brown-10dccde7.svg";